// src/belediye/components/BelediyeLayoutNoSidebar.js
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import BelediyeNavbar, { detayRotasiMi } from "./BelediyeNavbar";
import NotificationToaster from "./notifications/NotificationToaster";
// FAZ-87/93: katman + kaydırınca gizlenen navbar (saha kabuğu da mobil)
import useKatman from "../hooks/useKatman";
import useNavbarGizle from "../hooks/useNavbarGizle";
// FAZ-102: rota değişince kaydırma kabı tepeye döner
import useTepeyeDon from "../hooks/useTepeyeDon";
// FAZ-88: detay sayfası → navbar başlığı köprüsü (saha kabuğunda da geçerli;
// saha talep detayında sol yuva geri okuna döner)
import { NavbarBaslikSaglayici } from "./NavbarBaslikContext";
import "./BelediyeLayoutNoSidebar.css";

/**
 * Sidebar'sız Layout (Navbar + içerik)
 * - Mevcut BelediyeLayout'a benzer görsel yapı korunur.
 * - Sidebar render edilmez.
 * - Content alanında sidebar offset (margin-left) yoktur.
 *
 * Not: BelediyeNavbar içinde sidebar toggle butonu her zaman render ediliyorsa,
 * ileride Navbar'a "sidebarEnabled" gibi bir prop ekleyip butonu gizlemeniz gerekir.
 */
const BelediyeLayoutNoSidebar = ({ children, user, unitName, unitSlug }) => {
  // FAZ-52: bu kabukta sidebar YOK → tam ekran sohbet penceresi sola dayanır.
  // (BelediyeLayout ile aynı sözleşme; body'deki değişken tek kaynak.)
  useEffect(() => {
    document.body.style.setProperty("--md-sidebar-w", "0px");
    return () => document.body.style.removeProperty("--md-sidebar-w");
  }, []);

  /* FAZ-93 madde 4 — saha kabuğunda da geçerli: kullanıcı "tüm sayfalarda"
     dedi ve saha personeli sistemi zaten yalnız telefondan kullanıyor. */
  const icerikRef = useRef(null);
  const katmanAdi = useKatman();
  const { pathname } = useLocation();
  /* FAZ-98 / T-2 — yalnız telefon; gerekçe BelediyeLayout.js'te. Saha kabuğu
     da aynı kuralı alır: tablette navbar ekrandaki TEK kalıcı yüzey. */
  useNavbarGizle(icerikRef, katmanAdi === "telefon" && !detayRotasiMi(pathname));
  // FAZ-102 — saha kabuğu da aynı kuralı alır (bkz. hooks/useTepeyeDon.js).
  useTepeyeDon(icerikRef, pathname);

  return (
    <NavbarBaslikSaglayici>
    <div className="layout-root layout-root--no-sidebar">
      {/* Sağ-üst bildirim toast katmanı (panel geneli tek mount) */}
      <NotificationToaster />

      <BelediyeNavbar
        user={user}
        unitName={unitName}
        unitSlug={unitSlug}
        // Sidebar yok: toggle handler verilmez (Navbar bunu opsiyonel ele almalı)
        onSidebarToggle={undefined}
        // Navbar bu prop'u kullanmıyorsa sorun olmaz; ileride desteklemek için ekledik.
        sidebarEnabled={false}
      />

      <div className="layout-body">
        <main ref={icerikRef} className="layout-content layout-content--no-sidebar">
          <div className="layout-content-inner">{children}</div>
        </main>
      </div>
    </div>
    </NavbarBaslikSaglayici>
  );
};

export default BelediyeLayoutNoSidebar;
